<p-panel
  [toggleable]="true"
  [collapsed]="breakpoints.isMobile()"
  i18n-header="@@conversations.filters.header"
  header="Filters"
  styleClass="filters-panel-wrapper">
  <div class="filters-grid">
    <div class="filter-item">
      <label for="date-after" i18n="@@conversations.filter.dateAfter">Date After</label>
      <p-datepicker
        id="date-after"
        [ngModel]="dateAfter()"
        (ngModelChange)="dateAfter.set($event)"
        (onSelect)="onFilterChange()"
        (onClear)="onFilterChange()"
        [showClear]="true"
        i18n-placeholder="@@conversations.filter.selectDate"
        placeholder="Select date"
        class="filter-datepicker">
      </p-datepicker>
    </div>

    <div class="filter-item">
      <label for="date-before" i18n="@@conversations.filter.dateBefore">Date Before</label>
      <p-datepicker
        id="date-before"
        [ngModel]="dateBefore()"
        (ngModelChange)="dateBefore.set($event)"
        (onSelect)="onFilterChange()"
        (onClear)="onFilterChange()"
        [showClear]="true"
        i18n-placeholder="@@conversations.filter.selectDate"
        placeholder="Select date"
        class="filter-datepicker">
      </p-datepicker>
    </div>

    <div class="filter-item">
      <label for="status-filter" i18n="@@conversations.filter.status">Status</label>
      <p-select
        id="status-filter"
        [ngModel]="selectedStatus()"
        (ngModelChange)="selectedStatus.set($event)"
        [options]="statusOptions"
        optionLabel="label"
        optionValue="value"
        i18n-placeholder="@@conversations.filter.allStatuses"
        placeholder="All statuses"
        [showClear]="true"
        (onChange)="onFilterChange()"
        class="filter-select">
      </p-select>
    </div>

    <div class="filter-item">
      <label for="agent-filter" i18n="@@conversations.filter.agent">Agent</label>
      <p-select
        id="agent-filter"
        [ngModel]="selectedAgentId()"
        (ngModelChange)="selectedAgentId.set($event)"
        [options]="agentOptions()"
        optionLabel="label"
        optionValue="value"
        i18n-placeholder="@@conversations.filter.allAgents"
        placeholder="All agents"
        [showClear]="true"
        (onChange)="onFilterChange()"
        class="filter-select">
      </p-select>
    </div>
  </div>
</p-panel>

<!-- Список сессий.

     cdk-virtual-scroll вместо виртуального скроллера PrimeNG: последний
     переинициализируется при каждом изменении длины массива и сбрасывал
     прокрутку в начало на каждой подгрузке страницы (проверено в браузере).
     CDK рассчитан именно на append-only списки и позицию не теряет.

     Таблицы нет: строка — это grid, который на мобиле перестраивается
     в двухстрочную карточку одним media query (см. .list-row в CSS). -->
<div class="list-wrapper">
  <div class="list-head hide-mobile" role="presentation">
    <span i18n="@@conversations.col.date">Date</span>
    <span i18n="@@conversations.col.agent">Agent</span>
    <span i18n="@@conversations.col.duration">Duration</span>
    <span i18n="@@conversations.col.status">Status</span>
  </div>

  <cdk-virtual-scroll-viewport
    #viewport
    class="list-viewport"
    [itemSize]="rowHeight()"
    [minBufferPx]="rowHeight() * 6"
    [maxBufferPx]="rowHeight() * 12"
    (scrolledIndexChange)="onScrolledIndexChange($event, viewport.getViewportSize())">
    <a
      *cdkVirtualFor="let row of sessions(); trackBy: trackById"
      class="list-row"
      [style.height.px]="rowHeight()"
      [routerLink]="['/agents', row.agent_id, 'conversations', row.id]">
      <span class="cell cell-date">
        <span class="hide-mobile">{{ row.created_at | date:'MMM d, yyyy, h:mm a' }}</span>
        <span class="show-mobile">{{ row.created_at | date:'dd.MM HH:mm' }}</span>
      </span>
      <span class="cell cell-agent">{{ row.agent_title || unknownAgentLabel }}</span>
      <span class="cell cell-duration">{{ formatDuration(row.duration_seconds) }}</span>
      <span class="cell cell-status">
        <p-tag
          [value]="getStatusLabel(row.status)"
          [severity]="getStatusSeverity(row.status)">
        </p-tag>
      </span>
    </a>
  </cdk-virtual-scroll-viewport>

  @if (isLoading()) {
    <div class="list-status" role="status">
      <p-progressSpinner [style]="{ width: '24px', height: '24px' }" strokeWidth="4" />
    </div>
  } @else if (!sessions().length) {
    <div class="list-status list-empty" i18n="@@conversations.empty">No sessions found</div>
  } @else if (!hasMore()) {
    <div class="list-status list-end" i18n="@@conversations.endOfList">End of list</div>
  }
</div>
